{
  "badge": "Super admin",
  "consoleName": "Sahab platform console",
  "nav": {
    "label": "Console",
    "menu": "Menu",
    "tenants": "Tenants",
    "dashboard": "Dashboard",
    "subscriptions": "Subscriptions",
    "feedback": "Feedback"
  },
  "admin": {
    "menu": "Account menu for {{name}}",
    "profile": "Profile",
    "signOut": "Sign out",
    "signedOut": "Signed out of the console",
    "roles": {
      "OWNER": "Owner",
      "ADMIN": "Administrator",
      "SUPPORT": "Support"
    }
  },
  "login": {
    "title": "Platform console",
    "subtitle": "For Sahab operators only. Company users sign in at their own workspace.",
    "help": "Lost access? Another owner can reset your password from the operator command line.",
    "errors": {
      "invalidCredentials": "The email or password is incorrect. Check both and try again.",
      "rateLimited": "Too many sign-in attempts from this network. Wait a minute and try again.",
      "disabled": "The platform console is not set up on this server.",
      "invalidInput": "Enter your email address and password."
    },
    "hub": {
      "button": "Sign in with cloudTech Hub",
      "or": "or with a password",
      "only": "Super admins sign in with cloudTech Hub on this server.",
      "none": "Password sign-in is turned off and cloudTech Hub is not configured on this server.",
      "errors": {
        "noSuperAdmin": "Your cloudTech account has no active super admin account here. An owner can add one with the same email from the operator command line.",
        "notMfa": "cloudTech Hub did not confirm a second factor. Sign in to the Hub again.",
        "state": "That sign-in link expired or was already used. Try again.",
        "hubDenied": "cloudTech Hub did not sign you in.",
        "notConfigured": "cloudTech Hub sign-in is not configured on this server.",
        "failed": "Signing in through cloudTech Hub failed. Try again."
      }
    }
  },
  "errors": {
    "backToTenants": "Back to tenants",
    "tenantNotFound": "Tenant not found",
    "tenantNotFoundBody": "It may have been removed, or the address is wrong."
  },
  "conflict": {
    "title": "Someone else saved first",
    "body": "Your changes weren't saved. Load the latest version, then make your changes again.",
    "reload": "Load latest version"
  },
  "profile": {
    "title": "Your profile",
    "details": "Name and email",
    "name": "Name",
    "email": "Email",
    "currentPassword": "Current password",
    "currentPasswordHint": "Changing the email you sign in with needs your password.",
    "currentPasswordNeeded": "Enter your current password to change your email.",
    "currentPasswordWrong": "The current password is incorrect.",
    "emailTaken": "Another operator already uses this email.",
    "saved": "Profile saved",
    "discard": "Discard changes",
    "save": "Save profile",
    "passwordBody": "The password you sign in to the console with."
  },
  "status": {
    "ACTIVE": "Active",
    "SUSPENDED": "Suspended"
  },
  "fields": {
    "slug": "Workspace ID",
    "slugHint": "1 to 40 lowercase letters, digits and hyphens. It can't be changed later.",
    "slugOk": "Available format:",
    "slugFormat": "Use 1 to 40 lowercase letters, digits and hyphens, starting and ending with a letter or digit.",
    "slugReserved": "This name is reserved for the service. Choose another.",
    "name": "Company name",
    "nameAr": "Company name (Arabic)",
    "defaultLocale": "Default language",
    "defaultLocaleHint": "For new users and the company's printed documents.",
    "languages": {
      "en": "English",
      "ar": "Arabic"
    },
    "status": "Status",
    "modules": "Modules",
    "activeUsers": "Active users",
    "lastSignIn": "Last sign-in",
    "created": "Created",
    "adminName": "Name",
    "adminEmail": "Email",
    "adminPassword": "Password",
    "adminPasswordHint": "At least 10 characters. Share it with the administrator securely; they can change it later.",
    "showPassword": "Show password",
    "hidePassword": "Hide password"
  },
  "create": {
    "title": "New tenant",
    "subtitle": "A company on Sahab, with its own users and books.",
    "blocks": {
      "company": "Company",
      "legal": "Legal profile",
      "legalBody": "Printed at the head of the company's invoices and documents. The company can change it in Settings.",
      "modules": "Modules",
      "modulesBody": "What the company can use. Turned-off modules are hidden from its users.",
      "admin": "First administrator",
      "adminBody": "Signs in with every permission and invites the rest of the team.",
      "residency": "Data residency",
      "residencyBody": "Where the company's files and data are kept. It can be changed later only by moving the data."
    },
    "submit": "Create tenant",
    "failed": "The tenant wasn't created",
    "done": "{{name}} created",
    "slugTaken": "Another company already uses this workspace ID.",
    "emailTaken": "This email already belongs to a user. Use another one.",
    "confirmTitle": "Create the company without these modules?",
    "confirmBody": "Some ticked modules rely on modules left out (see the warnings). You can turn modules on later from the company's Modules tab.",
    "confirmCreate": "Create anyway"
  },
  "list": {
    "title": "Tenants",
    "count_one": "{{n}} company",
    "count_other": "{{n}} companies",
    "modulesOf": "{{n}} of {{total}}",
    "new": "New tenant",
    "searchPlaceholder": "Search name or workspace ID…",
    "searchLabel": "Search tenants",
    "clearSearch": "Clear search",
    "statusFilter": "Status",
    "allStatuses": "All statuses",
    "tableLabel": "Tenants",
    "clearFilters": "Clear filters",
    "empty": {
      "title": "No tenants yet",
      "body": "Add the first company to the service.",
      "filteredTitle": "No tenants match",
      "filteredBody": "Try another search or status."
    }
  },
  "detail": {
    "created": "Created {{date}}",
    "suspend": "Suspend",
    "activate": "Activate",
    "suspendTitle": "Suspend {{name}}?",
    "suspendBody": "Every user is signed out at once and nobody can sign in until the company is activated again. Its data is kept.",
    "activateTitle": "Activate {{name}}?",
    "activateBody": "The company's users can sign in again.",
    "reason": "Reason",
    "reasonHint": "Kept in the operator activity log.",
    "suspended": "{{name}} suspended",
    "activated": "{{name}} activated",
    "suspendedNotice": "This company is suspended: its users can't sign in.",
    "profileSaved": "Company profile saved",
    "saveProfile": "Save profile",
    "tabs": {
      "label": "Tenant",
      "profile": "Profile",
      "modules": "Modules",
      "users": "Users",
      "activity": "Activity",
      "subscriptions": "Subscriptions",
      "residency": "Residency"
    }
  },
  "modules": {
    "title": "Modules",
    "body": "What the company can use. Turning a module off hides it from every user; its data is kept.",
    "ownerOnly": "Only an owner can change a company's modules.",
    "needs": "Needs {{modules}}",
    "worksBestWith": "Works best with {{modules}}",
    "lostNeeds": "{{module}} needs {{dependency}}. {{reason}}.",
    "lostUses": "{{module}} works best with {{dependency}}. {{reason}}.",
    "workflowsOnHold_one": "{{n}} approval request is in progress. It will be put on hold — its document stays locked — until approval workflows are turned back on.",
    "workflowsOnHold_other": "{{n}} approval requests are in progress. They will be put on hold — their documents stay locked — until approval workflows are turned back on.",
    "subjectModuleOnHold_one": "{{n}} approval request is in progress. It will wait — its document stays locked — until {{module}} is turned back on.",
    "subjectModuleOnHold_other": "{{n}} approval requests are in progress. They will wait — their documents stay locked — until {{module}} is turned back on.",
    "shiftsOpen_one": "{{n}} till shift is open. Nobody can count or close it until POS is turned back on, so its cash stays uncounted. Ask the cashier to close it first.",
    "shiftsOpen_other": "{{n}} till shifts are open. Nobody can count or close them until POS is turned back on, so their cash stays uncounted. Ask the cashiers to close them first.",
    "collectionsUnverified_one": "{{n}} payment reported by technicians waits for verification. Nobody can verify it into a receipt until Service and Sales are both on.",
    "collectionsUnverified_other": "{{n}} payments reported by technicians wait for verification. Nobody can verify them into receipts until Service and Sales are both on.",
    "accountingLockDate": "The books are locked up to {{date}}. While Accounting is off nobody in the company can move this date, so nothing dated on or before it can be posted or voided.",
    "accountingFiscalYear": "The latest fiscal year ends on {{date}}. Later years are added on their own, 12 months each, but nobody in the company can close or reopen a year while Accounting is off.",
    "save": "Save modules",
    "saved": "Modules saved",
    "confirmTitle": "Save the modules despite the warnings?",
    "confirmBody": "The company keeps its data: turning a module back on restores it. The warnings above apply until then.",
    "confirmSave": "Save anyway"
  },
  "users": {
    "tableLabel": "Users",
    "name": "Name",
    "roles": "Roles",
    "status": "Status",
    "statuses": {
      "ACTIVE": "Active",
      "DISABLED": "Disabled"
    },
    "locked": "Locked",
    "lockedUntil": "Locked after failed sign-ins until {{date}}",
    "mustChange": "Must change password",
    "actions": "Actions",
    "resetPassword": "Reset password",
    "resetTitle": "Reset the password of {{name}}",
    "resetBody": "Type a new password and give it to them. They sign in with it as is and can change it later.",
    "newPasswordHint": "At least 10 characters. Share it with them securely.",
    "newPassword": "New password",
    "resetSubmit": "Reset password",
    "resetDone": "Password reset for {{name}}",
    "resetDoneBody": "Their open sessions were signed out. They sign in with the new password.",
    "empty": "This company has no users.",
    "signInAs": "Sign in as",
    "signInAsTitle": "Sign in as {{name}}",
    "signInAsSubmit": "Open the company app",
    "signInAsHour": "The company's app opens in this browser as {{email}}, for at most one hour.",
    "signInAsAudit": "It is recorded with your reason in the operator log and in the company's own audit log.",
    "signInAsReplaces": "Any company session already open in this browser is signed out.",
    "signInAsReasonHint": "For example, the support request you are working on."
  },
  "activity": {
    "label": "Operator activity",
    "empty": "No operator activity on this company yet.",
    "by": "by {{name}}",
    "actions": {
      "tenant_create": "Company created",
      "tenant_update": "Profile changed",
      "tenant_suspend": "Company suspended",
      "tenant_activate": "Company activated",
      "modules_set": "Modules changed",
      "user_password_reset": "User password reset",
      "user_impersonate": "Signed in as a user",
      "subscription_create": "Subscription added",
      "subscription_update": "Subscription changed",
      "subscription_cancel": "Subscription cancelled",
      "feedback_update": "Feedback updated",
      "auth_login": "Signed in",
      "auth_logout": "Signed out",
      "auth_login_failed": "Failed sign-in",
      "admin_profile_update": "Profile changed",
      "admin_password_change": "Password changed",
      "admin_create": "Super admin added",
      "admin_reset": "Super admin reset",
      "admin_disable": "Super admin disabled"
    }
  },
  "dashboard": {
    "title": "Dashboard",
    "figures": "Service figures",
    "activeCompanies": "Active companies",
    "suspended": "{{n}} suspended",
    "newCompanies": "New companies",
    "last30Days": "In the last 30 days",
    "activeUsers": "Active users",
    "subscriptions": "Active subscriptions",
    "activeSubscriptions_one": "{{n}} subscription, in <rial/>",
    "activeSubscriptions_other": "{{n}} subscriptions, in <rial/>",
    "openFeedback": "Open feedback",
    "openFeedbackDetail": "New and in progress",
    "endingSoon": "Ending within 30 days",
    "viewAll": "View all",
    "noneEnding": "No active subscription ends in the next {{n}} days.",
    "recentCompanies": "Recent companies",
    "recentActivity": "Recent operator activity",
    "noActivity": "No operator activity yet.",
    "ends": "ends {{date}}"
  },
  "subscriptions": {
    "title": "Subscriptions",
    "intro": "What each company pays. Kept for the record; nothing is enforced.",
    "new": "New subscription",
    "newTitle": "New subscription",
    "editTitle": "Edit subscription",
    "dialogBody": "Choose the company and the terms.",
    "tenant": "Company",
    "pickTenant": "Choose a company…",
    "pickerFailed": "Companies couldn't be loaded. Try again.",
    "startDate": "Start date",
    "endDate": "End date",
    "endDateHint": "Leave empty for an open-ended subscription.",
    "endBeforeStart": "The end date can't be before the start date.",
    "amount": "Amount",
    "currency": "Currency",
    "status": "Status",
    "notes": "Notes",
    "statuses": {
      "ACTIVE": "Active",
      "PAST_DUE": "Past due",
      "CANCELLED": "Cancelled",
      "EXPIRED": "Expired"
    },
    "openEnded": "Open-ended",
    "create": "Create subscription",
    "save": "Save subscription",
    "created": "Subscription added for {{name}}",
    "saved": "Subscription saved",
    "edit": "Edit",
    "cancel": "Cancel subscription",
    "keep": "Keep it",
    "cancelTitle": "Cancel the subscription of {{name}}?",
    "cancelBody": "It is marked cancelled and kept in the history. The company's access doesn't change.",
    "cancelled": "Subscription cancelled",
    "searchPlaceholder": "Search company…",
    "searchLabel": "Search subscriptions",
    "endingSoon": "Ending within 30 days",
    "tableLabel": "Subscriptions",
    "empty": "No subscriptions yet.",
    "emptyFiltered": "No subscriptions match.",
    "emptyTenant": "This company has no subscriptions.",
    "rowActions": "Actions for the subscription of {{name}}"
  },
  "feedback": {
    "title": "Feedback",
    "intro": "What companies sent from their app.",
    "views": "Feedback by status",
    "all": "All",
    "statuses": {
      "NEW": "New",
      "IN_PROGRESS": "In progress",
      "RESOLVED": "Resolved",
      "CLOSED": "Closed"
    },
    "types": {
      "BUG": "Bug",
      "FEATURE_REQUEST": "Feature request",
      "GENERAL": "General",
      "COMPLAINT": "Complaint"
    },
    "type": "Type",
    "allTypes": "All types",
    "subject": "Subject",
    "message": "Message",
    "company": "Company",
    "sender": "Sent by",
    "status": "Status",
    "received": "Received",
    "searchPlaceholder": "Search subject, message or company…",
    "searchLabel": "Search feedback",
    "tableLabel": "Feedback",
    "empty": "No feedback yet.",
    "emptyFiltered": "No feedback matches.",
    "setStatus": "Status",
    "adminNote": "Operators' note",
    "adminNoteHint": "Only operators see it.",
    "save": "Save",
    "saved": "Feedback updated"
  },
  "impersonation": {
    "label": "Signed in from the platform console",
    "banner": "You are signed in as {{name}} ({{email}}) by super admin {{admin}} until {{time}}",
    "short": "Super admin session · until {{time}}",
    "end": "End session"
  },
  "feedbackForm": {
    "menu": "Send feedback",
    "title": "Send feedback",
    "body": "Report a problem or suggest an improvement. The Sahab team reads every message.",
    "type": "Type",
    "subject": "Subject",
    "message": "Message",
    "submit": "Send",
    "sent": "Feedback sent",
    "sentBody": "Thank you. The Sahab team will look into it."
  },
  "residency": {
    "zone": {
      "OM": "Oman",
      "GLOBAL": "Global"
    },
    "zoneBody": {
      "OM": "Files and data stay in Oman, on in-country hosting.",
      "GLOBAL": "Files are stored in the platform's global region."
    },
    "requiresHosting": "Requires in-country hosting",
    "notConfigured": "This deployment has no storage for this zone.",
    "zonesUnknown": "The zones this deployment offers could not be read; Oman may be refused when you create the company.",
    "title": "Data residency",
    "body": "Where this company's files and data are kept. Only the platform owner can move them.",
    "current": "Data is kept in",
    "move": "Move data",
    "moveActive": "A move is already in progress. Wait for it to finish.",
    "noOtherZone": "This deployment offers no other zone.",
    "ownerOnly": "Only the platform owner can move a company's data.",
    "filesTitle": "Files by zone",
    "filesBody": "Every stored file and where it is now.",
    "noFiles": "This company has no files yet. A move would switch the zone at once.",
    "zoneColumn": "Zone",
    "filesColumn": "Files",
    "sizeColumn": "Size",
    "moveTitle": "Latest move",
    "noMove": "The data has never been moved.",
    "route": "{{from}} to {{to}}",
    "requestedBy": "Started by {{name}}, {{date}}",
    "requestedOn": "Started {{date}}",
    "inProgress": "Moving data from {{route}}…",
    "progress": "{{copied}} of {{total}} files copied and checked",
    "uploadsPaused": "Uploads for this company are paused until the move finishes. This page updates by itself.",
    "done": "Moved from {{route}} on {{date}}: {{total}} files copied and checked.",
    "failedTitle": "The move from {{route}} failed",
    "failedBody": "{{reason}} Every file stays in the old zone and nothing was lost.",
    "failure": {
      "HASH_MISMATCH": "A copied file did not match the original.",
      "OTHER": "The copy could not be completed."
    },
    "basisLabel": "Legal basis:",
    "dialog": {
      "title": "Move this company's data",
      "body": "Copy every file to another zone, check each copy, then switch the zone.",
      "confirm": "Start the move",
      "toZone": "Move to",
      "pickZone": "Choose where to move the data.",
      "basis": "Legal basis for the transfer out of Oman",
      "basisHint": "Kept in the operator log, e.g. the contract clause or the customer's written consent.",
      "basisNeeded": "Write the legal basis (at least {{n}} characters).",
      "slugMismatch": "Type the company's address exactly as shown.",
      "started": "Move to {{zone}} started",
      "whatHappens": "What happens",
      "copy_one": "{{n}} file is copied and its checksum checked.",
      "copy_other": "{{n}} files are copied and each checksum checked.",
      "paused": "Uploads pause for this company until the move ends.",
      "flip": "The zone switches only when every copy matches; otherwise nothing changes.",
      "typeSlug": "To confirm, type"
    },
    "checkingZones": "Checking whether this deployment offers it…",
    "zoneUnchecked": "Couldn't check whether this deployment offers it."
  },
  "messageUsage": {
    "title": "Messages sent",
    "body": "E-mails delivered for this company in the last 6 months, by channel, for pass-through billing. Message contents and addresses are not shown here.",
    "empty": "No messages sent yet",
    "emptyBody": "Counts appear here once the company sends its first e-mail, such as an invoice or an invitation.",
    "label": "Messages sent per month",
    "month": "Month",
    "channel": "Channel",
    "count": "Messages",
    "total": "Total, last 6 months",
    "channels": {
      "email": "E-mail"
    }
  },
  "aiPolicy": {
    "title": "AI assistant policy",
    "body": "The monthly token cap the company's own limit stays under, the models it may choose, and a suspension. The company pays OpenAI itself, under its own key.",
    "none": "This company has no AI policy yet, so the assistant is blocked. Save one to allow it.",
    "suspendedNotice": "Suspended",
    "adminOnly": "Only a platform administrator can change the AI policy.",
    "usedOf": "{{used}} of {{cap}} tokens used this month ({{percent}})",
    "used": "{{used}} tokens used this month",
    "meter": "Tokens used this month",
    "updated": "Last changed {{date}}",
    "cap": "Monthly token cap",
    "capHint": "The company can set its own limit at or below it.",
    "capInvalid": "Enter a whole number of tokens up to 10,000,000,000",
    "tokensUnit": "tokens a month",
    "models": "Allowed models",
    "modelsHint": "Model ids, e.g. gpt-5-mini. None listed: every model this deployment offers.",
    "modelsPlaceholder": "Every model of the deployment",
    "modelsInvalid": "Use a model id such as gpt-5-mini",
    "checklistHint": "Tick the models the company may choose. None ticked: every model this deployment offers.",
    "notOffered": "No longer offered by this deployment",
    "chips": {
      "remove": "Remove {{value}}",
      "added": "Added {{value}}. {{n}} models listed.",
      "removed": "Removed {{value}}. {{n}} models listed.",
      "limit": "Up to {{max}} models.",
      "notAdded": "{{n}} not added: up to {{max}} models."
    },
    "suspend": "Suspend the assistant for this company",
    "suspendHint": "Nobody in the company can use it until it is resumed here. Its settings are kept.",
    "reason": "Reason",
    "reasonHint": "Shown to operators; recorded in the console's activity.",
    "reasonRequired": "Say why the assistant is suspended",
    "save": "Save AI policy",
    "saved": "AI policy saved",
    "areas": "Areas",
    "areasHint": "What the company may use the assistant for. An area left out shows in the company’s settings as not allowed, and its runs are refused.",
    "areaNames": {
      "general": "Assistant on every page",
      "projects": "Projects assistant",
      "accounting": "Accounting assistant",
      "inventory": "Inventory assistant",
      "purchasing": "Purchasing assistant",
      "service": "Service assistant"
    },
    "areaHints": {
      "general": "Answers from every area allowed here, on any page.",
      "purchasing": "Reads whole supplier bills (photos and PDFs).",
      "service": "Sets up sites, places and equipment; reads equipment lists and documents (photos and PDFs)."
    },
    "areasNone": "No area is allowed: the company can’t use the assistant."
  }
}
